import React from 'react';

export const Title = ({ titleText }: { titleText: string }) => <h1 className="title">{titleText}</h1>;
